/**
 * GEDCOM export types — re-exported from the generated API client.
 */
export type {
  CreateGedcomExportRequest,
  GedcomExportBaselineResponse,
  GedcomExportFormat,
  GedcomExportMode,
  GedcomExportResponse,
  GedcomExportStats
} from 'we-tree-api-client/v2';

export {
  GedcomExportFormat as GedcomExportFormatValues,
  GedcomExportMode as GedcomExportModeValues
} from 'we-tree-api-client/v2';

import type { GedcomExportFormat } from 'we-tree-api-client/v2';

/** Format values for the export-modal version picker (labels via i18n). */
export const GEDCOM_EXPORT_FORMATS: ReadonlyArray<GedcomExportFormat> = ['5.5.1', '7.0'];
